import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import Note from "~/primitiveComponents/form/Note/Note";
import type { CategoryDefinition } from "./endpointRegistry";
const category: CategoryDefinition = {
    category: "Kubernetes",
    title: (<React.Fragment>
            Let's setup a <strong>Kubernetes</strong> target.
        </React.Fragment>),
    help: (<Note>
            Learn more about <ExternalLink href="KubernetesTarget">Kubernetes targets</ExternalLink>
        </Note>),
    displayOrder: 10,
};
export default category;
